module.exports = __webpack_public_path__ + "static/media/coin.8b74e632.png";